"use client";

import NextLink from "next/link";
import { usePathname } from "next/navigation";

import { usePageMessage } from "#app/_ui/components/errors/use-page-message";
import { UnauthorizedFooter } from "#app/_ui/components/footers/UnauthorizedFooter";
import { PageOutageAlertBanner } from "#app/_ui/components/outages/page-outage-alert-banner";
import { PageOutageMain } from "#app/_ui/components/outages/page-outage-main";
import { HeaderWithSlots } from "#ui/header";
import { LandmarkLink } from "#ui/landmark-link";
import { LinkButtonCloseResponsive } from "#ui/link";
import { Logo } from "#ui/logo";

export default function Layout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const dataPageMessage = usePageMessage({ path: pathname });

  return (
    <>
      <LandmarkLink type="trigger" slug="main" label="main content" />
      <LandmarkLink type="trigger" slug="footer" label="footer content" />
      <HeaderWithSlots
        layout="mobileOnly"
        slot0={
          <NextLink href="/">
            {/* TODO: Convert dual logos to one responsive logo */}
            <Logo layout="mark-only" size="xs" className="sm:hidden" />
            <Logo layout="mark-and-word" size="xs" className="max-sm:hidden" />
          </NextLink>
        }
        slot2={
          <LinkButtonCloseResponsive href="/sign-in">
            Back to sign in
          </LinkButtonCloseResponsive>
        }
      />
      <PageOutageAlertBanner data={dataPageMessage} />
      <LandmarkLink type="target" slug="main" label="main content" />
      <PageOutageMain data={dataPageMessage}>{children}</PageOutageMain>
      <LandmarkLink type="target" slug="footer" label="footer content" />
      <UnauthorizedFooter />
    </>
  );
}
